import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import React from 'react';
import Aux from '../../../hoc/Auxilary/Auxilary';

export default function CheckboxField(props) {
    const { checked, label, onChange, disabled, name, required, 'data-cy': dataCy } = props;

    return (
      <Aux>
        <FormControlLabel
            data-cy={dataCy}
            control={<Checkbox checked={checked || false} color='secondary' onChange={onChange} name={name} required={required} disabled={disabled}/>}
            label={label} disabled={disabled}
        />
      </Aux>
    );
  };
